/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-04",
    versionChannel: "nightly",
    buildDate: "2025-06-04T00:07:14.016Z",
    commitHash: "57c67198ed604e8050a077014143061526844c5f",
};
